// extracted by mini-css-extract-plugin
export default {"rating":"WJ-z","numberOfStars":"XJ-z","count":"YJ-z","barGraphSpacing":"ZJ-z","barGraph":"_J-z"};